module.exports = __webpack_public_path__ + "img/icon-shipping-box.5f54e57d.svg";